import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

class FiltroOrigem extends Filtro {
    tipo = 'selecao';
    exibicao = 'checkbox';

    get label() {
        return 'Sistema de tramitação (origem)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.processo.origem;
    }

    get isHabilitado() {
        return this.store.isSessaoMista();
    }
}

export default FiltroOrigem;
